import { useState, useCallback } from 'react';

export const useImageModal = () => {
  const [imageModal, setImageModal] = useState({ 
    isOpen: false, 
    imageUrl: '', 
    alt: '', 
    startRect: null 
  });

  const openImageModal = useCallback((imageUrl, alt = 'Image', imageElement = null) => {
    let startRect = null;
    if (imageElement) {
      startRect = imageElement.getBoundingClientRect();
    }
    setImageModal({ isOpen: true, imageUrl, alt, startRect });
  }, []);

  const closeImageModal = useCallback(() => {
    setImageModal({ isOpen: false, imageUrl: '', alt: '', startRect: null });
  }, []);

  return {
    imageModal,
    openImageModal,
    closeImageModal
  };
};